import { useQuery } from '@apollo/client';
import * as R from 'ramda';
import { ApolloProviderV4 } from '~/apollo/client-v4';
import { BookmarkParentType } from '~/apollo/generated/v3/graphql';
import { graphql } from '~/apollo/generated/v4';
import { NotFound } from '~/components/common/NotFound';
import { SpinnerPlaceholder } from '~/components/common/SpinnerPlaceholder';
import { SOItemListV4 } from '~/components/supporting-object/so-item-list-v4';
import { TaggedSOItemListV4 } from '~/components/supporting-object/tagged-so-item-list-v4';
import { useRouteParam } from '~/hooks/routing';
import { createRefetchQueries } from '~/utils/graphql';

const OUTCROP_RESERVOIR_MODELS_PAGE = graphql(`
  query OutcropReservoirModelsPage($id: ID!) {
    outcropGet(id: $id) {
      id
      reservoirModels {
        ...reservoirModelParts
        pictures {
          ...soPictureParts
        }
        files {
          ...fileParts
        }
      }

      studies {
        ...studyParts
        reservoirModels {
          ...reservoirModelParts
          pictures {
            ...soPictureParts
          }
          files {
            ...fileParts
          }
        }
      }
    }
  }
`);

export default function OutcropReservoirModelsPage() {
  return (
    <ApolloProviderV4>
      <OutcropReservoirModelsPageInner />
    </ApolloProviderV4>
  );
}

function OutcropReservoirModelsPageInner() {
  const outcropId = useRouteParam('outcropId', parseInt);

  const { data, loading } = useQuery(OUTCROP_RESERVOIR_MODELS_PAGE, {
    variables: { id: outcropId },
  });

  const refetchQueries = createRefetchQueries([
    { query: OUTCROP_RESERVOIR_MODELS_PAGE, variables: { id: outcropId } },
  ]);

  const outcrop = data?.outcropGet;
  const items = outcrop?.reservoirModels ?? [];
  const outcropStudies = R.sortBy(s => s.name, outcrop?.studies ?? []);

  if (loading) return <SpinnerPlaceholder />;
  if (!outcrop) return <NotFound />;

  return (
    <>
      <SOItemListV4
        items={items}
        soParentType="outcrop"
        soParentId={outcropId}
        bookmarkParentType={BookmarkParentType.ReservoirModel}
        refetchQueries={refetchQueries}
      />

      <TaggedSOItemListV4
        outcropId={outcropId}
        studies={outcropStudies}
        supportObjectKey="reservoirModels"
        refetchQueries={refetchQueries}
      />
    </>
  );
}
